/* * @Author: 曹俊杰 * @Date: 2022-05-06 15:18:30 * @Module: 客服 */
<template>
  <div class="service">
    <div class="service-bottom">
      <div class="service-bottom-1" @click="setServicepopupvisible({visible:true})">
        <div class="icon kefu" />
        <p>平台客服</p>
      </div>

      <div class="service-bottom-2" @click="$utils.help()">
        <div class="icon bangzhu" />
        <p>帮助中心</p>
      </div>
      <div
        class="service-bottom-2 chaozhi"
        @click="showChaozhilibao"
        :class="{ canBuy: user.monthBundleCount > 0 }"
      >
        <img src="@/assets/image/service/icon3.png" class="icon" alt="" srcset="" />
        <p>超值礼包</p>
      </div>
    </div>
  </div>
</template>
<script>
import userinfo from "@/mixins/userinfo.js";
import { mapActions } from "vuex";
export default {
  // components: { chaozhilibao },
  mixins: [userinfo],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    ...mapActions("chaozhilibao", ["onShow", "onHide"]),
    ...mapActions("app", ["setServicepopupvisible"]),
    async showChaozhilibao() {
      await this.verifyUserAuth();
      if (this.user.monthBundleCount > 0) {
        this.onShow();
      } else {
        this.$message.warning("此礼包每月仅限购买一次");
      }
    },
    kefu() {
      this.$im.open();
    },
  },
};
</script>
<style lang="scss">
.service {
  position: fixed;
  right: 20px;
  bottom: 70px;
  z-index: 4;
  // transform: translateY(-50%); /* 上移自身高度的 50% */
  cursor: pointer;
  .icon {
    width: 20px;
    height: 20px;
  }

  &-bottom {
    margin-top: 10px;
    width: 56px;
    height: calc(144px / 2 * 3);
    flex-shrink: 0;
    border-radius: 100px;
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0px 4px 16px 0px rgba(38, 38, 38, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-1,
    &-2 {
      width: 56px;
      height: 56px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #666;
      font-family: "Noto Sans SC";
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      p {
        margin-top: 4px;
      }
    }
  }
}
.kefu {
  background-image: url(~@/assets/image/home/header/icon_9.webp);
  background-size: 100%;
  &:hover {
    background-image: url(~@/assets/image/home/header/icon_2.webp);
    background-size: 100%;
  }
}
.bangzhu {
  background-image: url(~@/assets/image/home/header/icon_1.webp);
  background-size: 100%;
  &:hover {
    background-image: url(~@/assets/image/home/header/icon_8.webp);
    background-size: 100%;
  }
}

.chaozhi {
  .icon {
    filter: grayscale(100%);
  }
}
.canBuy {
  .icon {
    -webkit-animation: jello-horizontal 2s infinite both;
    animation: jello-horizontal 0.9s infinite both;
    filter: grayscale(0%);
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2025-5-20 3:28:56
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

@-webkit-keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
.jello-horizontal {
  -webkit-animation: jello-horizontal 2s infinite both;
  animation: jello-horizontal 0.9s infinite both;
}
</style>
